var components
try {
  components = {
    uImage: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-image/u-image" */ "uview-ui/components/u-image/u-image.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uTabsSwiper: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-tabs-swiper/u-tabs-swiper" */ "uview-ui/components/u-tabs-swiper/u-tabs-swiper.vue"
      )
    },
    mpHtml: function () {
      return import(
        /* webpackChunkName: "uni_modules/mp-html/components/mp-html/mp-html" */ "@/uni_modules/mp-html/components/mp-html/mp-html.vue"
      )
    },
    uCollapse: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse/u-collapse" */ "uview-ui/components/u-collapse/u-collapse.vue"
      )
    },
    uCollapseItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-collapse-item/u-collapse-item" */ "uview-ui/components/u-collapse-item/u-collapse-item.vue"
      )
    },
    uTimeLine: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-time-line/u-time-line" */ "uview-ui/components/u-time-line/u-time-line.vue"
      )
    },
    uTimeLineItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-time-line-item/u-time-line-item" */ "uview-ui/components/u-time-line-item/u-time-line-item.vue"
      )
    },
    empty: function () {
      return import(
        /* webpackChunkName: "components/empty/empty" */ "@/components/empty/empty.vue"
      )
    },
    uToast: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-toast/u-toast" */ "uview-ui/components/u-toast/u-toast.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.course.free_roles && _vm.course.free_roles.length > 0
  var m0 = g0 ? _vm.transVipRole(_vm.course.free_roles) : null
  var g1 = _vm.chapterList && _vm.chapterList.length > 0
  var l1 = g1
    ? _vm.__map(_vm.chapterList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var m1 = _vm.canShowVideo(item)
        var g2 = item.videos.length
        var l0 =
          g2 > 0
            ? _vm.__map(item.videos, function (video, __i0__) {
                var $orig = _vm.__get_orig(video)
                var g3 = _vm.vk.pubfn.timeFormat(
                  new Date(video.start_time),
                  "yyyy-MM-dd hh:mm"
                )
                var g4 = Date.now()
                var g5 = Date.now()
                var g6 =
                  video.start_time <= Date.now() && video.end_time >= Date.now()
                return {
                  $orig: $orig,
                  g3: g3,
                  g4: g4,
                  g5: g5,
                  g6: g6,
                }
              })
            : null
        return {
          $orig: $orig,
          m1: m1,
          g2: g2,
          l0: l0,
        }
      })
    : null
  var g7 = _vm.chapterList && _vm.chapterList.length > 0
  var l2 = g7
    ? _vm.__map(_vm.chapterList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g8 = _vm.vk.pubfn.isNull(item.word)
        return {
          $orig: $orig,
          g8: g8,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        m0: m0,
        g1: g1,
        l1: l1,
        g7: g7,
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }